import React from "react";
import { TABLES } from "../../Utils/tableConst"
import { Table } from "../Table"

export const TableQuery4 = () => (
  <Table tableData={TABLES.QUERY_4} theme="horizontal" />
);
